var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"redirect"},[_c('div',{staticClass:"redirect__text"},[_c('h1',{staticClass:"heading",domProps:{"innerHTML":_vm._s(
        _vm.$t('PLEASE_WAIT_N_SECONDS_TILL_LINK', {
          seconds: _vm.timer,
        })
      )}}),_c('router-link',{attrs:{"to":"/my/buy"}},[_vm._v(_vm._s(_vm.$t('WANT TO SKIP THIS?'))+"\n      "+_vm._s(_vm.$t('BUY_PLUS'))+"\n    ")]),_c('p',{staticClass:"text g-text",domProps:{"innerHTML":_vm._s(_vm.$t('STEVE_JOBS_QUOTE'))}})],1),_c('img',{staticClass:"redirect__img",attrs:{"src":require("@/assets/redirect.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }